export const menuData =
  ({ openApplications, setOpenApplications, openProducts, setOpenProducts }) =>
  ({ t, SubMenuItem }) => {
    return [
      {
        exact: true,
        to: '/who-we-are',
        labelLink: t('menu.who-we-are'),
      },
      {
        exact: false,
        to: '/applications',
        openCloseValue: openApplications,
        openCloseCallback: setOpenApplications,
        labelLink: t('menu.applications'),
        subMenu: (
          <div style={{ padding: '20px', display: 'flex' }}>
            <div style={{ marginRight: '100px' }}>
              <SubMenuItem
                title="Back-up / Datacenter (POWER)"
                isPff={true}
                closeCallback={setOpenApplications}
                subMenuList={[
                  {
                    title: 'Energy',
                    linkTo: '/energyDataCenter',
                    active: true,
                  },
                ]}
              />
              <SubMenuItem
                title="Maritime"
                isPff={true}
                closeCallback={setOpenApplications}
                subMenuList={[
                  {
                    title: 'Energy',
                    linkTo: '/energyMaritime',
                    active: true,
                  },
                ]}
              />
              <SubMenuItem
                title="Renewables / Stationary"
                isPff={true}
                closeCallback={setOpenApplications}
                subMenuList={[
                  {
                    title: 'Power',
                    linkTo: '/power',
                    active: true,
                  },
                ]}
              />
            </div>
          </div>
        ),
      },
      {
        exact: false,
        to: '/products',
        openCloseValue: openProducts,
        openCloseCallback: setOpenProducts,
        labelLink: t('menu.products'),
        subMenu: (
          <div style={{ padding: '20px', display: 'flex' }}>
            <div style={{ marginRight: '100px' }}>
              <SubMenuItem
                title="Stationary (POWER)"
                isPff={true}
                closeCallback={setOpenProducts}
                subMenuList={[
                  {
                    title: 'Battery Rack series P4F 196S-T',
                    linkTo: '/stationary',
                    active: true,
                  },
                ]}
              />
              <SubMenuItem
                title="Maritime (ENERGY)"
                isPff={true}
                closeCallback={setOpenProducts}
                subMenuList={[
                  {
                    title: 'LiBECCIO®',
                    linkTo: '/maritime',
                    active: true,
                  },
                ]}
              />
            </div>
          </div>
        ),
      },
      {
        exact: false,
        to: '/news',
        labelLink: t('menu.news'),
      },
      {
        exact: false,
        to: '/contacts',
        labelLink: t('menu.contacts'),
      },
    ];
  };
